// Getters
export const CURRENT_USER = 'currentUser'
export const IS_AUTHENTICATED = 'isAuthenticated'

export const AUTH_CURRENT_USER = 'auth/' + CURRENT_USER
export const AUTH_IS_AUTHENTICATED = 'auth/' + IS_AUTHENTICATED

// Actions
export const CHECK_AUTH = 'checkAuth'
export const AUTH_CHECK_AUTH = 'auth/' + CHECK_AUTH
export const LOGIN = 'login'
export const GET_TOKEN = 'getToken'
export const GET_IS_INVITE = 'getIsInvite'
export const REQUEST_TOKEN = 'requestToken'

export const AUTH_LOGIN = 'auth/' + LOGIN
export const AUTH_GET_TOKEN = 'auth/' + GET_TOKEN
export const AUTH_GET_IS_INVITE = 'auth/' + GET_IS_INVITE

// Mutations
export const SET_AUTH = 'setAuth'
export const UPDATE_USER = 'updateUser'
export const PURGE_AUTH = 'purgeAuth'
export const SET_TOKEN = 'setToken'
export const SET_IS_INVITE = 'setIsInvite'

export const AUTH_SET_AUTH = 'auth/' + SET_AUTH
export const AUTH_SET_IS_INVITE = 'auth/' + SET_IS_INVITE
export const AUTH_UPDATE_USER = 'auth/ ' + UPDATE_USER
export const AUTH_PURGE_AUTH = 'auth/' + PURGE_AUTH
export const AUTH_SET_TOKEN = 'auth/' + SET_TOKEN
export const AUTH_REQUEST_TOKEN = 'auth/' + REQUEST_TOKEN



// WEBPACK FOOTER //
// ./src/store/auth/auth.types.js